<template>
  <v-container v-bind:class="{ 'pa-0': reference }">
    <v-row justify="center" v-bind:class="{ 'pa-0': reference }">
      <v-col cols="12" :md="reference ? 12 : 7" v-if="data && !error" v-bind:class="{ 'pa-0': reference }">
        <v-card class="text-center">
          <v-card-title class="title font-weight-regular">
            <v-col cols="12" class="text-center">
            {{ $t('payment.titles.main') }}
            </v-col>
          </v-card-title>
          <v-divider />
          <v-card-text class="pt-8 pb-12">
            <v-row v-bind:class="{ 'ma-0': reference }">
              <v-col cols="6" class="text-right body-1 font-weight-regular">
                {{ $t('payment.messages.id-transaction') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium">
                {{ data.merchant_order_id }}
              </v-col>
            </v-row>
            <v-row v-bind:class="{ 'ma-0': reference }">
              <v-col cols="6" class="text-right body-1 font-weight-regular">
                {{ $t('payment.messages.reference') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium">
                {{ data.external_reference }}
              </v-col>
            </v-row>
            <v-row v-bind:class="{ 'ma-0': reference }">
              <v-col cols="6" class="text-right body-1 font-weight-regular">
                {{ $t('payment.messages.date') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium">
                {{ data.date }}
              </v-col>
            </v-row>
            <v-row v-bind:class="{ 'ma-0': reference }">
              <v-col cols="6" class="text-right body-1 font-weight-regular">
                {{ $t('payment.messages.value') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium">
                <v-icon class="mx-n1">attach_money</v-icon>
                {{ data.value }}
              </v-col>
            </v-row>
            <v-row v-bind:class="{ 'ma-0': reference }">
              <v-col cols="6" class="text-right body-1 font-weight-regular">
                {{ $t('payment.messages.status') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium">
                {{ $t('payment.status.'+data.collection_status) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="7" v-else-if="!error && loaded">
        <v-alert icon="warning" type="warning" class="mt-5">{{ $t('errors.payment.empty') }}</v-alert>
      </v-col>
      <v-col cols="12" md="7" v-if="error && loaded">
        <v-alert icon="warning" type="warning" class="mt-5">{{ error }}</v-alert>
      </v-col>
    </v-row>

    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
// import { getPaymentByReference, savePaymentApproved } from '@/store/module/billing'

import { savePaymentApproved, getPaymentApprovedByReference } from '@/store/module/billing'
import { getDateBySeconds } from '@/store/service'

export default {
  props: {
    reference: null,
  },
  data() {
    return {
      error: null,
      loaded: false,
      data: null
    }
  },
  created() {
    console.log('Created', this.$route)
    // By URL
    if (this.$route.query.external_reference) {
      let data = this.$route.query
      window.history.pushState({}, document.title, '/#' + this.$route.path)
      if (data.external_reference && data.collection_status === 'approved') {
        savePaymentApproved(data.external_reference, data)
        .then(redirect => {
          // Redirect
          if (!redirect) {
            this.$router.push({ name: 'Billing' })
          } else {
            this.loadPayment(data.external_reference)
          }
        })
      } else if (data.collection_status === 'rejected') {
        this.error = this.$t('errors.payment.rejected')
        this.loaded = true
      } else if (data.collection_status === 'pending') {
        this.error = this.$t('errors.payment.pending')
        this.loaded = true
      } else {
        this.error = this.$t('errors.payment.unknow')
        this.loaded = true
      }
    } else {
      let reference = this.$route.params.reference ? this.$route.params.reference : this.reference
      if (reference) {
        this.loadPayment(reference)
      }
    }
  },
  methods: {
    loadPayment(reference) {
      getPaymentApprovedByReference(reference)
      .then(payment => {
        if (payment) {
          this.data = payment.response
          this.data.value = parseInt(payment.payment.value).toLocaleString('es-ES')
          this.data.date = getDateBySeconds(payment.payment.created_at)
        } else {
          this.error = this.$t('errors.payment.not-found')
        }
        this.loaded = true
      })
      .catch(error => {
        console.log('ERROR', error.message);
        this.loaded = true
      })
    }
  }
}
</script>
